import { useState } from "react";
import { cx } from "../../utils/cx";
import { formatCount as fmt, formatShare } from "./format";

// Horizontal bars, largest first, scaled to the largest count; hovering a row shows its share
export default function BarChart({ items, emptyText = "Nothing recorded for this year" }) {
  const [activeKey, setActiveKey] = useState(null);
  const total = items.reduce((sum, i) => sum + i.value, 0);
  if (!total) return <p className="text-sm text-slate-500">{emptyText}</p>;

  const rows = [...items].sort((a, b) => b.value - a.value);
  const max = rows[0].value;

  return (
    <ul className="flex flex-col gap-1">
      {rows.map((row) => (
        <li
          key={row.key}
          onMouseEnter={() => setActiveKey(row.key)}
          onMouseLeave={() => setActiveKey(null)}
          className={cx(
            "grid grid-cols-[minmax(6rem,9rem)_1fr_auto] items-center gap-3 rounded-md px-2 py-1.5 text-sm transition-colors",
            activeKey === row.key && "bg-slate-50"
          )}
        >
          <span className="truncate text-slate-600" title={row.label}>
            {row.label}
          </span>
          <span className="h-3">
            <span
              className={cx("block h-full rounded-r bg-brand transition-opacity", activeKey && activeKey !== row.key && "opacity-40")}
              style={{ width: `${Math.max((row.value / max) * 100, 2)}%` }}
            />
          </span>
          <span className="flex items-baseline justify-end gap-2">
            <span className="font-semibold text-slate-900">{fmt(row.value)}</span>
            <span className={cx("w-9 text-right text-xs text-slate-400", activeKey !== row.key && "invisible")}>
              {formatShare(row.value, total)}
            </span>
          </span>
        </li>
      ))}
    </ul>
  );
}
